import * as yup from "yup";

export const KitTrackingSchema = yup.object().shape({
    orderDate: yup.string(),
    clientName: yup.string(),
    clientContactNumber: yup.string(),
    clientAddress: yup.string(),
    typeOfKit: yup.string(),
    courierServiceProvider: yup.string(),
    courierServiceProviderPersonName: yup.string(),
    courierServiceProviderPersonContactNumber: yup.string(),
    courierTrackingId: yup.string(),
    kitDispatchAddress: yup.string(),
    dispatchDate: yup.string(),
    kitPrice: yup.string(),
    courierServiceCharge: yup.string(),
    deliveryDate: yup.string(),
    generatedBy: yup.string(),
    note: yup.string(),
    kitStatus: yup.string(),
});